/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Play_Help_VisitInputs */

const en_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit Google Play Help to cancel`)
};

const id_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunjungi Bantuan Google Play untuk membatalkan`)
};

const ms_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lawati Google Play Help untuk batalkan`)
};

const ca_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per cancel·lar, visita el centre d'ajuda de Google Play`)
};

const cs_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro zrušení navštivte nápovědu obchodu Google Play`)
};

const da_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besøg Google Play Hjælp for at opsige`)
};

const de_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe zu Google Play-Hilfe, um zu kündigen`)
};

const et_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tühistamiseks külastage Google Pay abi`)
};

const es_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al soporte de Google Play para cancelar`)
};

const fr_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultez le centre d’aide Google pour annuler.`)
};

const hr_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posjetite Google Play Help kako biste otkazali`)
};

const it_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visita la Guida di Google Play per cancellare`)
};

const lv_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apmeklējiet Google Play palīdzības centru, lai atceltu`)
};

const lt_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norėdami atšaukti, apsilankykite „Google Play“ pagalbos svetainėje`)
};

const hu_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Törléshez látogasson el a Google Play Súgó oldalára`)
};

const nl_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar Google Play Help om op te zeggen`)
};

const nb_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til Google Play for å si opp`)
};

const pl_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odwiedź stronę pomocy Google Play, aby anulować`)
};

const pt_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesse a Ajuda do Google Play para cancelar`)
};

const ro_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vizitează Ajutor Google Play pentru a anula`)
};

const sk_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre zrušenie navštívte službu Google Play Pomocník`)
};

const sl_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiščite Pomoč trgovine Google Play in prekličite`)
};

const fi_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käy Google Playn ohjekeskuksessa peruuttaaksesi`)
};

const sv_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besök Google Play Help för att avbryta`)
};

const vi_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truy cập Trung tâm trợ giúp của Google Play để hủy`)
};

const tr_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal etmek için Google Play Yardım'ı ziyaret edin`)
};

const el_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επισκεφθείτε την Υποστήριξη του Google Play για ακύρωση`)
};

const bg_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посетете Google Play Help, за да отмениш`)
};

const ru_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посетите раздел Помощь Google Play, чтобы отменить действие`)
};

const sr_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посетите подршку за Google Play да откажете`)
};

const uk_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зв'яжіться зі службою підтримки Google Play, щоб скасувати підписку`)
};

const ka_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გაუქმებისთვის მიმართეთ Google Play-ის მხარდაჭერას`)
};

const hi_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करने के लिए गूगल प्ले हेल्प पर जाएँ`)
};

const th_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปที่ Google Play Help เพื่อยกเลิก`)
};

const ko_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play 도움말 방문하여 취소`)
};

const zh_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问 Google Play 帮助以取消`)
};

const zh_tw_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請前往 Google Play 說明取消`)
};

const ja_google_play_help_visit = /** @type {(inputs: Google_Play_Help_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセルするにはGoogle Play ヘルプにアクセスしてください`)
};

/**
* | output |
* | --- |
* | "Visit Google Play Help to cancel" |
*
* @param {Google_Play_Help_VisitInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const google_play_help_visit = /** @type {((inputs?: Google_Play_Help_VisitInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Play_Help_VisitInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_google_play_help_visit(inputs)
	if (locale === "ms") return ms_google_play_help_visit(inputs)
	if (locale === "ca") return ca_google_play_help_visit(inputs)
	if (locale === "cs") return cs_google_play_help_visit(inputs)
	if (locale === "da") return da_google_play_help_visit(inputs)
	if (locale === "de") return de_google_play_help_visit(inputs)
	if (locale === "et") return et_google_play_help_visit(inputs)
	if (locale === "es") return es_google_play_help_visit(inputs)
	if (locale === "fr") return fr_google_play_help_visit(inputs)
	if (locale === "hr") return hr_google_play_help_visit(inputs)
	if (locale === "it") return it_google_play_help_visit(inputs)
	if (locale === "lv") return lv_google_play_help_visit(inputs)
	if (locale === "lt") return lt_google_play_help_visit(inputs)
	if (locale === "hu") return hu_google_play_help_visit(inputs)
	if (locale === "nl") return nl_google_play_help_visit(inputs)
	if (locale === "nb") return nb_google_play_help_visit(inputs)
	if (locale === "pl") return pl_google_play_help_visit(inputs)
	if (locale === "pt") return pt_google_play_help_visit(inputs)
	if (locale === "ro") return ro_google_play_help_visit(inputs)
	if (locale === "sk") return sk_google_play_help_visit(inputs)
	if (locale === "sl") return sl_google_play_help_visit(inputs)
	if (locale === "fi") return fi_google_play_help_visit(inputs)
	if (locale === "sv") return sv_google_play_help_visit(inputs)
	if (locale === "vi") return vi_google_play_help_visit(inputs)
	if (locale === "tr") return tr_google_play_help_visit(inputs)
	if (locale === "el") return el_google_play_help_visit(inputs)
	if (locale === "bg") return bg_google_play_help_visit(inputs)
	if (locale === "ru") return ru_google_play_help_visit(inputs)
	if (locale === "sr") return sr_google_play_help_visit(inputs)
	if (locale === "uk") return uk_google_play_help_visit(inputs)
	if (locale === "ka") return ka_google_play_help_visit(inputs)
	if (locale === "hi") return hi_google_play_help_visit(inputs)
	if (locale === "th") return th_google_play_help_visit(inputs)
	if (locale === "ko") return ko_google_play_help_visit(inputs)
	if (locale === "zh") return zh_google_play_help_visit(inputs)
	if (locale === "zh-tw") return zh_tw_google_play_help_visit(inputs)
	if (locale === "ja") return ja_google_play_help_visit(inputs)
	return en_google_play_help_visit(inputs)
});